import React from 'react';
import { View } from '@shared/components/View';
import { MBSeparator } from '@shared/components/list';
import { MBScrollView } from '@shared/components/scrollview';
import { Colors, bounceIn } from '@shared/styles';
import { API } from '@shared/types/api';
import { MBAttachmentRow } from './row';

export interface MBAttachmentListProps {
  attachments: API.ChatAttachmentFragment[];
  onRemove: (attachment: API.ChatAttachmentFragment) => void;
}

export class MBAttachmentListComponent extends React.PureComponent<MBAttachmentListProps> {
  render() {
    if (!this.props.attachments.length) {
      return null;
    }
    return (
      <>
        <MBScrollView horizontal>
          <View row paddingRight={1}>
            {/* reverse to show newest attachments first */}
            {this.props.attachments
              .map((attachment, index) => (
                <View
                  key={attachment.fileKey}
                  className={bounceIn}
                  padding={0.5}
                  paddingRight={index === 0 ? 0 : undefined}
                >
                  <MBAttachmentRow attachment={attachment} onRemove={this.props.onRemove} />
                </View>
              ))
              // Reverse the attachments to show the latest one first.
              // The reason we do this after ".map" is because reverse
              // mutates the original array. We don't want that since
              // this would mutate the redux store where the attachments
              // are stored.
              .reverse()}
          </View>
        </MBScrollView>
        <MBSeparator color={Colors.v2.gray10} />
      </>
    );
  }
}
